import React, { Component } from 'react';
import ReactGA from 'react-ga';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import { makeGetAllpushNotificationsState } from 'store/selectors';
import { Button, SearchInput, Spinner } from 'components';
import ItemModal from './ItemModal';
import CreateModal from './CreateModal';
import { logger, permissions } from 'helpers';
import * as actions from 'store/actions';
// import tableConfig from './configs/table';
import { startOfDay, endOfDay, format } from 'date-fns';
import ListView from '../../components/ListView';
import { AuxWrap } from 'hoc';
import { handleLabel } from 'helpers';

import {
	Update,
	LocationOne,
	Discount,
	Service,
	Pair,
	Replace,
	Billing,
	Advertisements,
	Reminder,
	DataLog,
} from 'components/Icons';
import {
	errorsParams,
	getFiltersParam,
	getRolesParams,
	getSearchInputParams,
	providersParams,
	modelsParams,
} from './Configs/paramsCreator';

import s from './style.module.scss';
import i18next from 'i18next';
import { withTranslation } from 'react-i18next';
import SelectComponent from '../../../src/components/UI/SelectComponent';
import { TableDateFilter } from 'components';
// import { TableDateFilter } from 'components';

const firmwaresParams = (perm) => {
	if (!perm) {
		return {
			search: {
				status_id: [1, 3],
			},
			searchFields: {
				status_id: 'in',
			},
		};
	}

	return {};
};

export const columnProps = [
	{ Header: '#', accessor: 'id', sort: false },
	{ Header: i18next.t('title'), accessor: 'title', sort: false },
	{ Header: i18next.t('departments'), accessor: ['user', 'name'], sort: false },
	{
		Header: i18next.t('types'),
		accessor: 'push_type',
		sort: false,
		Cell: ({ value }) => {
			if (!permissions.check('notifications.history_push_types')) return;

			let icon;

			switch (value && value.code) {
				case 'update':
					icon = (
						<>
							<Update newLogo={true} />
							{i18next.t('Software Updates')}
						</>
					);
					break;
				case 'location':
					icon = <LocationOne />;
					break;
				case 'discount':
				case 'promotion':
					icon = (
						<>
							<Discount newLogo={true} /> {i18next.t('Promotions')}
						</>
					);
					break;
				case 'service':
					icon = (
						<>
							<Service newLogo={true} />
							{i18next.t('Maintenance and Service')}
						</>
					);
					break;
				case 'pair':
					icon = <Pair />;
					break;
				case 'replace':
					icon = <Replace />;
					break;
				case 'billing':
					icon = <Billing />;
					break;
				case 'advertisement':
					icon = (
						<>
							<Advertisements newLogo={true} /> {i18next.t('Advertisements')}
						</>
					);
					break;
				case 'reminder':
					icon = <Reminder />;
					break;
				case 'data_transfer':
					icon = (
						<>
							<DataLog newLogo={true} /> {i18next.t('Transfer Data')}
						</>
					);
					break;

				default:
					// icon = null;
					icon = 'No icon';
					break;
			}

			return icon;
		},
	},
	{
		Header: i18next.t('date'),
		accessor: 'created_at',
		Cell: ({ value }) => {
			const date = new Date(value);
			const day = date.getDate().toString().padStart(2, '0');
			const month = (date.getMonth() + 1).toString().padStart(2, '0');
			const year = date.getFullYear().toString();
			return `${month}.${day}.${year}`;
		},
		sort: true,
	},
	{
		Header: i18next.t('status'),
		accessor: 'push_notification_schedule',
		sort: false,
		Cell: ({ value }) => {
			if (value && !value.length) {
				return <>{i18next.t('sent')}</>;
			}

			if (value && value.every((schedule) => schedule.status === 1)) {
				return <>{i18next.t('scheduled')}</>;
			}

			if (value && value.some((schedule) => schedule.status === 2)) {
				return <>{i18next.t('sent')}</>;
			}

			return null;
		},
	},
];
class PushNotifications extends Component {
	constructor(props) {
		super(props);

		// withTracker({
		// 	page: props.location.pathname,
		// 	category: "Notifications",
		// 	action: "Page view",
		// });

		this.state = {
			searchValue: '',
			isSearch: false,
			modal: {
				isOpen: false,
			},
			createModal: {
				isOpen: false,
			},
			tableFilters: {},
			filters: {},
			sortColumn: 'created_at',
			sortDirection: 'desc',
			selectedRoles: [],
			selectedTypes: [],
			hasLoadMore: false,
			pageSize: 40,
		};

		props.getPushNotificationsHistory(props.requestParams);
		props.getPushNotificationsTypes();
		props.getPushNotificationsFirmwares({
			params: firmwaresParams(
				permissions.check('notifications.firmware_full_list'),
			),
		});
		props.getErrors({ params: errorsParams });
		props.getRoles(getRolesParams());
		// To pass param from config file
		props.getModels({ params: modelsParams });
		props.getProviders(providersParams);
		props.getFirmwaresNotifiable();

		if (permissions.check('notifications.provider.filter')) {
			props.getProvidersNotifiable();
		}

		if (!permissions.check('providers.main.filter')) {
			props.getPinCodes();
		}
	}

	componentWillUnmount() {
		logger('[PushNotifications] componentWillUnmount');

		this.props.clearPushNotifications();
	}

	// Function to perform deep comparison of two objects
	deepEqual(obj1, obj2) {
		if (obj1 === obj2) {
			return true;
		}

		if (
			typeof obj1 !== 'object' ||
			obj1 === null ||
			typeof obj2 !== 'object' ||
			obj2 === null
		) {
			return false;
		}

		const keys1 = Object.keys(obj1);
		const keys2 = Object.keys(obj2);

		if (keys1.length !== keys2.length) {
			return false;
		}

		for (let key of keys1) {
			if (!keys2.includes(key) || !this.deepEqual(obj1[key], obj2[key])) {
				return false;
			}
		}

		return true;
	}

	componentDidUpdate(prevProps, prevState) {
		logger('[PushNotifications] componentDidUpdate');
		const { requestParams, getPushNotificationsHistory, setRequestParam } =
			this.props;
		const { filters } = this.state;
		const isFiltersChange = filters !== prevState.filters;

		// Trigger on limit change
		if (prevProps.requestParams.limit !== requestParams.limit) {
			getPushNotificationsHistory(requestParams);
			this.tableOffset = prevProps.requestParams.limit;
		}

		// Trigger on search object change
		if (
			(requestParams?.search?.body &&
				requestParams.search.body !== prevProps.requestParams?.search?.body) ||
			(requestParams?.search?.created_at &&
				requestParams.search.created_at !==
					prevProps.requestParams?.search?.created_at)
		) {
			getPushNotificationsHistory(requestParams);
			this.tableOffset = prevProps.requestParams.limit;
		} else if (
			requestParams?.search &&
			prevProps?.requestParams?.search &&
			Object.keys(requestParams.search).length ===
				Object.keys(prevProps.requestParams.search).length
		) {
			const isSearchChange = !this.deepEqual(
				requestParams.search,
				prevProps.requestParams.search,
			);
			if (isSearchChange) {
				getPushNotificationsHistory(requestParams);
				this.tableOffset = prevProps.requestParams.limit;
			}
		}

		// Trigger if sortedBy changed
		if (requestParams?.sortedBy && prevProps?.requestParams?.sortedBy) {
			const isSortedByChange = !this.deepEqual(
				requestParams.sortedBy,
				prevProps.requestParams.sortedBy,
			);
			if (isSortedByChange) {
				getPushNotificationsHistory(requestParams);
				this.tableOffset = prevProps.requestParams.limit;
			}
		}

		if (prevProps.tableLoading !== this.props.tableLoading) {
			this.setState({ hasLoadMore: false });
		}

		if (isFiltersChange) {
			const { providers = {} } = filters;
			const providerIds = Object.keys(providers).length
				? Object.keys(providers)
				: null;
			setRequestParam(getFiltersParam(providerIds));
		}
	}

	onSearchTyping = (event, { newValue }) => {
		this.setState({ searchValue: newValue });

		if (!newValue) {
			this.onSearchSubmit(null);
		}
	};

	onSearchSubmit = (value) => {
		const params = getSearchInputParams(value);

		ReactGA.event({
			category: 'Notifications',
			action: 'Submit',
			label: 'Search field',
		});

		this.props.setRequestParam(params);
		this.setState({ isSearch: !!value });
	};

	onSearchClear = () => {
		this.setState({ searchValue: '' });
		this.onSearchSubmit(null);
	};

	onRowClicked = (row) => {
		ReactGA.event({
			category: 'Notifications',
			action: 'Click',
			label: 'Table row',
		});

		this.setState({ modal: { isOpen: true, rowId: row.id } });
	};

	onCreateNotification = () => {
		ReactGA.event({
			category: 'Notifications',
			action: 'Click',
			label: i18next.t('create_notification'),
		});

		this.setState({ createModal: { isOpen: true, restrictClosing: true } });
	};

	modalClose = () => {
		this.setState({
			modal: { isOpen: false },
			createModal: { isOpen: false, restrictClosing: false },
		});
	};

	loadMoreHandler = () => {
		const params = {
			...this.props.requestParams,
			offset: this.tableOffset,
		};
		this.tableOffset += this.props.requestParams.limit;
		this.props.getPushNotificationsHistory(params, true);
	};

	updateNotifications = () => {
		this.props.getPushNotificationsHistory(
			this.props.requestParams,
			null,
			true,
		);
	};

	getTopText = () => {
		const { tableLoading: loading, historyRows: rows } = this.props;
		const isShow = loading ? 0 : 1;

		let text = (
			<span className={s.textSearch} style={{ opacity: isShow }}>
				{rows} {i18next.t('results_were_found')}
			</span>
		);

		if (!this.state.isSearch) {
			const opacity = rows || 0;
			text = (
				<span className={s.tableText} style={{ opacity }}>
					{i18next.t('history')} ({rows})
				</span>
			);
		}

		return text;
	};

	onFilterAdd = (item, key, parent) => {
		ReactGA.event({
			category: 'PushNotifications',
			action: 'Click',
			label: `Select ${key} filter`,
		});

		this.setState((ps) => {
			const filters = { ...ps.filters };
			item = Array.isArray(item) && !item.length ? null : item;
			if (item) {
				if (filters[key]) {
					if (filters[key][item.id]) {
						delete filters[key][item.id];
					} else {
						filters[key][item.id] = item;
					}
				} else {
					filters[key] = { [item.id]: item };
				}
			} else {
				filters['pinCodes'] = {};
				filters['providers'] = {};
			}

			if (key === 'pinCodes') {
				const isAllChecked =
					parent && parent.provider_codes.every((el) => filters[key][el.id]);

				if (isAllChecked) {
					filters.providers
						? (filters.providers[parent.id] = parent)
						: (filters.providers = { [parent.id]: parent });

					parent.provider_codes.forEach((el) => {
						filters[key][el.id] && delete filters[key][el.id];
					});
				} else if (filters.providers) {
					filters.providers[item.provider_id] &&
						delete filters.providers[item.provider_id];
				}
			}

			if (key === 'providers' && filters.pinCodes) {
				if (filters[key] && filters[key][item.id]) {
					const providerCodes = filters[key][item.id].provider_codes;
					if (providerCodes) {
						providerCodes.forEach((el) => {
							if (filters.pinCodes && filters.pinCodes[el.id]) {
								delete filters.pinCodes[el.id];
							}
						});
					}
				}
			}
			return { filters };
		});
	};

	handleSortChange = (column, direction) => {
		this.setState({
			sortColumn: column,
			sortDirection: direction,
		});

		this.props.setRequestParam({
			orderBy: column,
			sortedBy: direction,
		});
	};

	setRequestParamsWithAPICall = (param, val) => {
		this.props.setRequestParam({
			search: {
				[param]: val.length ? val : null,
			},
			searchFields: {
				[param]: val.length ? 'in' : null,
			},
		});
	};

	tableOffset = this.props.requestParams.limit;

	render() {
		logger('[PushNotifications] Render');

		const {
			searchValue,
			modal,
			createModal,
			tableFilters,
			// filters,
			tableFilters: { createdDate },
		} = this.state;
		const {
			typesWithIconData,
			providersData,
			currentUserData,
			errorsData,
			modelsData,
			providersNotifiabledata,
			firmwaresNotifiabledata,
			firmwaresData,
			statesData,
			timezonesData,
			citiesData,
			// requestParams,
			addPushNotification,
			setRequestParam,
			user,
			t,
			// tableLoading: loading
		} = this.props;
		let isSuperAdminUser = false;
		if (
			currentUserData &&
			currentUserData?.roles &&
			currentUserData?.roles?.length
		) {
			// check if the user is super admin
			currentUserData.roles.forEach((role) => {
				if (role.name === 'superadmin') {
					isSuperAdminUser = true;
				}
			});
		}

		const handleRolesTypeChange = (roles) => {
			this.setState({
				selectedRoles: roles,
			});
			this.setRequestParamsWithAPICall('user.roles.id', roles);
		};

		const handleChangedTypes = (types) => {
			this.setState({
				selectedTypes: types,
			});
			this.setRequestParamsWithAPICall('push_type_id', types);
		};

		// eslint-disable-next-line no-unused-vars
		const filterProps = (filterName) => ({
			checked: tableFilters[filterName] || {},
			data: this.props[`${filterName}Data`],
			onItemClick: (data, config) => {
				this.setState(
					(prevState) => {
						const prevFilters = { ...prevState.tableFilters };
						const filter = prevFilters[filterName] || {};

						if (filter[data.id]) {
							delete filter[data.id];
						} else {
							filter[data.id] = {
								[config.displayField]: data[config.displayField],
								[config.valuesField]: data[config.valuesField],
							};
						}

						prevFilters[filterName] = filter;

						return { tableFilters: prevFilters };
					},
					() => {
						const { valuesField, param } = config;
						const filter = this.state.tableFilters[filterName] || {};
						const values = Object.values(filter).map((el) => el[valuesField]);
						setRequestParam({
							search: {
								[param]: values.length ? values : null,
							},
							searchFields: {
								[param]: values.length ? 'in' : null,
							},
						});
					},
				);
			},
			defaultChanged: (config) =>
				setRequestParam({
					search: {
						[config.param]: null,
					},
					searchFields: {
						[config.param]: null,
					},
				}),
			clear: () =>
				this.setState((prevState) => ({
					tableFilters: {
						...prevState.tableFilters,
						[filterName]: {},
					},
				})),
		});

		const dateFilterProps = (dateState = {}, filterName) => ({
			checked: dateState.checked,
			singleDate: dateState.singleDate,
			toDate: dateState.toDate,
			fromDate: dateState.fromDate,
			singleChange: (date, config) => {
				this.setState(
					(prevState) => {
						const filtersState = { ...prevState.tableFilters };
						const filter = filtersState[filterName] || {};

						filter.singleDate = date;
						filter.fromDate = null;
						filter.toDate = null;

						filtersState[filterName] = filter;

						return { tableFilters: filtersState };
					},
					() => {
						this.props.setRequestParam({
							search: {
								[config.param]: [
									// dateState.singleDate
									// 	.startOf('day')
									// 	.format('YYYY-MM-DDTHHmmss'),
									format(
										startOfDay(dateState.singleDate),
										"yyyy-MM-dd'T'HHmmss",
									),
									// dateState.singleDate.endOf('day').format('YYYY-MM-DDTHHmmss'),
									format(endOfDay(dateState.singleDate), "yyyy-MM-dd'T'HHmmss"),
								],
							},
							searchFields: { [config.param]: 'between' },
						});
					},
				);
			},
			fromChange: (date, config) => {
				this.setState(
					(prevState) => {
						const filtersState = { ...prevState.tableFilters };
						const filter = filtersState[filterName] || {};

						if (moment(date).isAfter(filter.toDate)) {
							filter.fromDate = date;
							filter.toDate = null;
							filter.singleDate = null;
						} else {
							filter.fromDate = date;
							filter.singleDate = null;
						}

						filtersState[filterName] = filter;

						return { tableFilters: filtersState };
					},
					() => {
						if (dateState.toDate) {
							this.props.setRequestParam({
								search: {
									[config.param]: [
										// date.startOf('day').format('YYYY-MM-DDTHHmmss'),
										// dateState.toDate.endOf('day').format('YYYY-MM-DDTHHmmss'),
										format(startOfDay(date), "yyyy-MM-dd'T'HHmmss"),
										format(endOfDay(dateState.toDate), "yyyy-MM-dd'T'HHmmss"),
									],
								},
								searchFields: { [config.param]: 'between' },
							});
						}
					},
				);
			},
			toChange: (date, config) => {
				this.setState(
					(prevState) => {
						const filtersState = { ...prevState.tableFilters };
						const filter = filtersState[filterName] || {};

						if (moment(date).isBefore(filter.fromDate)) {
							filter.fromDate = null;
							filter.toDate = date;
							filter.singleDate = null;
						} else {
							filter.toDate = date;
							filter.singleDate = null;
						}

						filtersState[filterName] = filter;

						return { tableFilters: filtersState };
					},
					() => {
						if (dateState.fromDate) {
							this.props.setRequestParam({
								search: {
									[config.param]: [
										// dateState.fromDate
										// 	.startOf('day')
										// 	.format('YYYY-MM-DDTHHmmss'),
										// date.endOf('day').format('YYYY-MM-DDTHHmmss'),
										format(
											startOfDay(dateState.fromDate),
											"yyyy-MM-dd'T'HHmmss",
										),
										format(endOfDay(date), "yyyy-MM-dd'T'HHmmss"),
									],
								},
								searchFields: { [config.param]: 'between' },
							});
						}
					},
				);
			},
			clearSelect: (config) =>
				this.props.setRequestParam({
					search: { [config.param]: null },
					searchFields: { [config.param]: null },
				}),
			itemClicked: (el) => {
				this.setState((prevState) => {
					const filtersState = { ...prevState.tableFilters };
					const filter = filtersState[filterName] || {};

					filter.checked = el.id;
					filter.singleDate = null;
					filter.fromDate = null;
					filter.toDate = null;

					filtersState[filterName] = filter;

					return { tableFilters: filtersState };
				});
			},
			clear: () => () => {},
		});
		const createdDateConfig = {
			type: 'date',
			param: 'created_at',
			data: [
				{
					id: 1,
					label: 'all',
				},
				{
					id: 2,
					label: 'single_date',
					type: 'single',
				},
				{
					id: 3,
					label: 'period_of_time',
					type: 'period',
				},
			],
			defaultValue: 'Date',
			propsKey: 'createdDateFilterProps',
			label: {
				path: 'description',
			},
		};

		const loadMoreData = () => {
			this.setState({ hasLoadMore: true, pageSize: this.state.pageSize + 40 });
			// this.loadMoreHandler();
			this.props.setRequestParam({
				limit: this.props.requestParams.limit + 40,
			});
		};

		const handleScroll = (e) => {
			const element = e.target;

			// Calculate how far the user has scrolled from the top
			const scrollPosition = element.scrollTop;

			// Calculate the maximum scroll position (total scrollable height - container height)
			const maxScroll = element.scrollHeight - element.clientHeight;

			// Calculate the threshold as a percentage of the container's height
			const thresholdPercentage = 10; // You can adjust this percentage as needed
			const threshold = (element.clientHeight * thresholdPercentage) / 100;
			// // Check if the user has scrolled to the bottom within the threshold
			if (maxScroll - scrollPosition <= threshold && !this.state.hasLoadMore) {
				loadMoreData();
			}
		};

		return (
			<div className={s.page}>
				<div className={s.content}>
					<h1 className={s.pageTitle}>{i18next.t('notifications')}</h1>
					<div className={s.secondaryHeader}>
						<SearchInput
							className={s.searchForm}
							theme='violet'
							btnType='searchViolet'
							value={searchValue}
							placeholder={t('search_messages_via_keywords')}
							disabled={this.props.tableLoading}
							onChange={this.onSearchTyping}
							onSearchSubmit={() => this.onSearchSubmit(searchValue)}
							onClear={this.onSearchClear}
						/>
						<Button
							className={s.createBtn}
							btnType={'type-20'}
							clicked={this.onCreateNotification}
						>
							<svg
								width='24'
								height='24'
								viewBox='0 0 24 24'
								fill='none'
								xmlns='http://www.w3.org/2000/svg'
								style={{ marginRight: '10px' }}
							>
								<path
									d='M11.9983 21.6923C11.5007 21.6923 11.0753 21.5153 10.7221 21.1613C10.3689 20.8073 10.1923 20.3817 10.1923 19.8846H13.8077C13.8077 20.3833 13.6305 20.8093 13.2762 21.1625C12.9218 21.5157 12.4959 21.6923 11.9983 21.6923ZM5.0673 18.8846C4.90657 18.8846 4.77183 18.8297 4.6631 18.7201C4.55437 18.6104 4.5 18.4745 4.5 18.3124C4.5 18.1503 4.55437 18.016 4.6631 17.9096C4.77183 17.8032 4.90657 17.75 5.0673 17.75H6.3077V9.8519C6.3077 8.49789 6.71859 7.29048 7.54037 6.22968C8.36218 5.16886 9.43205 4.51121 10.75 4.25673V3.75C10.75 3.40278 10.8714 3.10765 11.1143 2.8646C11.3571 2.62153 11.6519 2.5 11.9989 2.5C12.3458 2.5 12.641 2.62153 12.8846 2.8646C13.1282 3.10765 13.25 3.40278 13.25 3.75V4.25688C13.6012 4.33049 13.9381 4.4327 14.2606 4.5635C14.5831 4.69428 14.8866 4.86029 15.1711 5.06153C15.0258 5.20994 14.9 5.36531 14.7939 5.52763C14.6877 5.68996 14.5807 5.85573 14.473 6.02495C14.1153 5.7865 13.7277 5.60509 13.31 5.48073C12.8923 5.35638 12.4556 5.2942 12 5.2942C10.7372 5.2942 9.66183 5.73811 8.774 6.62593C7.88618 7.51374 7.44227 8.58907 7.44227 9.8519V17.75H16.5577V14.0615C16.7397 14.1769 16.9217 14.2805 17.1035 14.3724C17.2853 14.4642 17.4816 14.544 17.6922 14.6115V17.75H18.9327C19.0934 17.75 19.2281 17.8048 19.3369 17.9145C19.4456 18.0242 19.5 18.1601 19.5 18.3222C19.5 18.4843 19.4456 18.6186 19.3369 18.725C19.2281 18.8314 19.0934 18.8846 18.9327 18.8846H5.0673ZM19.0673 9.56728H16.4519C16.2911 9.56728 16.1564 9.51244 16.0477 9.40278C15.9389 9.29309 15.8846 9.15719 15.8846 8.99508C15.8846 8.83296 15.9389 8.6987 16.0477 8.5923C16.1564 8.48588 16.2911 8.43268 16.4519 8.43268H19.0673V5.8173C19.0673 5.65657 19.1221 5.52183 19.2318 5.4131C19.3414 5.30437 19.4773 5.25 19.6395 5.25C19.8016 5.25 19.9358 5.30437 20.0422 5.4131C20.1487 5.52183 20.2019 5.65657 20.2019 5.8173V8.43268H22.8172C22.978 8.43268 23.1127 8.48751 23.2215 8.59718C23.3302 8.70686 23.3846 8.84276 23.3846 9.00488C23.3846 9.16699 23.3302 9.30125 23.2215 9.40765C23.1127 9.51407 22.978 9.56728 22.8172 9.56728H20.2019V12.1827C20.2019 12.3434 20.147 12.4781 20.0374 12.5869C19.9277 12.6956 19.7918 12.75 19.6297 12.75C19.4676 12.75 19.3333 12.6956 19.2269 12.5869C19.1205 12.4781 19.0673 12.3434 19.0673 12.1827V9.56728Z'
									fill='white'
								/>
							</svg>

							{t('create_notification')}
						</Button>
					</div>

					<div className={s.secondaryHeader}>
						<h1 className={s.pageTitle}>{this.getTopText()}</h1>
						<AuxWrap>
							<div className={s.filtersSection}>
								{isSuperAdminUser === false ? null : (
									<SelectComponent
										options={providersData}
										value={this.state.filters.providers ? Object.keys(this.state.filters.providers) : []}
										onChange={this.onFilterAdd}
										isMulti={true}
										placeholder={i18next.t('providers_all')}
										overRideValueKey='id'
										overRideLabelKey='name'
										className={s.selectfilterStyling}
										customPropsType='providers'
									/>
								)}

								<SelectComponent
									options={handleLabel(this.props.rolesData)}
									value={this.state.selectedRoles}
									onChange={handleRolesTypeChange}
									isMulti={true}
									placeholder={i18next.t('departments_all')}
									overRideValueKey='id'
									overRideLabelKey='label'
									className={s.selectfilterStyling}
								/>

								<SelectComponent
									options={handleLabel(this.props.typesData)}
									value={this.state.selectedTypes}
									onChange={handleChangedTypes}
									isMulti={true}
									placeholder={i18next.t('types_all')}
									overRideValueKey='id'
									overRideLabelKey='label'
									className={s.selectfilterStyling}
								/>

								<TableDateFilter
									config={createdDateConfig}
									onSetParams={setRequestParam}
									newDesign={true}
									{...dateFilterProps(createdDate, 'createdDate')}
								/>
							</div>
						</AuxWrap>
					</div>

					<div onScroll={(e) => handleScroll(e)} className={s.tableContainer}>
						{this.props?.historyData?.length >= 0 ? (
							<ListView
								data={this.props.historyData}
								columnSettings={columnProps}
								pageSize={this.state.pageSize}
								defaultSortColumn={this.state.sortColumn}
								defaultSortColumnDirection={this.state.sortDirection}
								className={s.table}
								infiniteScroll={true}
								staticData={false}
								stylingProps={s}
								onClickChange={this.onRowClicked}
								onSortChange={this.handleSortChange}
							/>
						) : (
							<div>
								<Spinner />
							</div>
						)}
					</div>
					{this.state.hasLoadMore === true && (
						<div className={s.spinnerDiv}>
							<Spinner />
						</div>
					)}

					{/* <Table
                        className={s.table}
                        config={tableConfig}
                        data={this.props.historyData}
                        loading={this.props.tableLoading}
                        requestParams={requestParams}
                        onSetParams={setRequestParam}
                        onRowClicked={this.onRowClicked}
                        loadMoreHandler={this.loadMoreHandler}
                        hasMoreData={this.props.hasMorehistoryData}
                        topText={this.getTopText()}
                        typesFilterProps={filterProps('types')}
                        rolesFilterProps={filterProps('roles')}
                        createdDateFilterProps={dateFilterProps(createdDate, 'createdDate')}
                        infinite /> */}
				</div>

				<ItemModal
					itemId={modal.rowId}
					isOpen={modal.isOpen}
					closeModal={this.modalClose}
					timezonesData={timezonesData}
				/>

				{createModal.isOpen ? (
					<CreateModal
						typesData={typesWithIconData}
						errorsData={errorsData}
						currentUserData={currentUserData}
						providersData={providersData}
						modelsData={modelsData}
						providersNotifiabledata={providersNotifiabledata}
						firmwaresNotifiabledata={firmwaresNotifiabledata}
						firmwaresData={firmwaresData}
						statesData={statesData}
						timezonesData={timezonesData}
						citiesData={citiesData}
						isOpen={createModal.isOpen}
						restrictClosing={createModal.restrictClosing}
						update={this.updateNotifications}
						addPushNotification={addPushNotification}
						closeModal={this.modalClose}
						user={user}
					/>
				) : null}
			</div>
		);
	}
}

PushNotifications.propTypes = {
	requestParams: PropTypes.shape({
		limit: PropTypes.number,
		search: PropTypes.object,
		sortedBy: PropTypes.string,
	}).isRequired,
	getPushNotificationsHistory: PropTypes.func.isRequired,
	setRequestParam: PropTypes.func.isRequired,
};

const mapStateToProps = () => {
	const getAllpushNotificationsState = makeGetAllpushNotificationsState();

	return (props, state) => getAllpushNotificationsState(props, state);
};

const mapDispatchToProps = (dispatch) => {
	return {
		getPushNotificationsHistory: (options, isMerge, loading) =>
			dispatch(actions.getPushNotificationsHistory(options, isMerge, loading)),
		getPushNotificationsTypes: () =>
			dispatch(actions.getPushNotificationsTypes()),

		getPushNotificationsFirmwares: (options) =>
			dispatch(actions.getPushNotificationsFirmwares(options)),
		addPushNotification: (data) => dispatch(actions.addPushNotification(data)),

		getErrors: (args) => dispatch(actions.getErrors(args)),
		getModels: (args) => dispatch(actions.getModels(args)),
		getProvidersNotifiable: (args) =>
			dispatch(actions.getProvidersNotifiable(args)),
		getFirmwaresNotifiable: (args) =>
			dispatch(actions.getFirmwaresNotifiable(args)),
		getRoles: (args) => dispatch(actions.getRoles(args)),
		getProviders: (args) => dispatch(actions.getProviders(args)),
		getCurrentUser: () => dispatch(actions.getCurrentUser()),
		getPinCodes: (args) => dispatch(actions.getPinCodes(args)),

		setRequestParam: (params) =>
			dispatch(actions.setPushNotificationsRequestParam(params)),
		clearPushNotifications: () => dispatch(actions.clearPushNotifications()),
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(withTranslation()(PushNotifications));
